module.exports = __webpack_public_path__ + "static/lao-5476d4e8f87f1cc929864817e99a8f89.svg";